import Common from '../../Common';

const User = class extends Common {
	// @ts-expect-error please i just want to build this project
	async browse(companyId: id, light?: boolean, status?: boolean): CustomResponse<User[]> {
		const gets: {[key: string]: any} = {};

		if(light) {
			gets['light'] = 1;
		}

		if(status) {
			gets['status'] = 1;
		}

		return this.get(
			"/company/{companyId}/users"
			.replace('{companyId}', companyId + '') +
			this.getGETVariables(gets)
		);
	}
}

export default User
